var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cpm-page" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "cpm-stats" }, [
      _c("div", { staticClass: "cpm-stat cpm-stat--blue" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "cpm-stat__body" }, [
          _c("div", { staticClass: "cpm-stat__val" }, [
            _vm._v("$" + _vm._s(_vm.formatAmount(_vm.stats.total_revenue)))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cpm-stat__lbl" }, [_vm._v("Total Revenue")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cpm-stat" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "cpm-stat__body" }, [
          _c("div", { staticClass: "cpm-stat__val" }, [
            _vm._v(_vm._s(_vm.stats.total))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cpm-stat__lbl" }, [_vm._v("All Payments")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cpm-stat cpm-stat--green" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "cpm-stat__body" }, [
          _c("div", { staticClass: "cpm-stat__val" }, [
            _vm._v(_vm._s(_vm.stats.completed))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cpm-stat__lbl" }, [_vm._v("Completed")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cpm-stat cpm-stat--amber" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "cpm-stat__body" }, [
          _c("div", { staticClass: "cpm-stat__val" }, [
            _vm._v(_vm._s(_vm.stats.pending))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cpm-stat__lbl" }, [_vm._v("Pending")])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cpm-stat cpm-stat--red" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "cpm-stat__body" }, [
          _c("div", { staticClass: "cpm-stat__val" }, [
            _vm._v(_vm._s(_vm.stats.failed))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cpm-stat__lbl" }, [_vm._v("Failed")])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cpm-card" }, [
      _c(
        "div",
        { staticClass: "cpm-toolbar" },
        [
          _c(
            "div",
            { staticClass: "cpm-toolbar__filters" },
            [
              _c(
                "el-select",
                {
                  staticClass: "cpm-toolbar__sel",
                  attrs: {
                    clearable: "",
                    placeholder: "All Forms",
                    size: "small",
                    loading: _vm.formsLoading
                  },
                  on: { change: _vm.onFilterChange },
                  model: {
                    value: _vm.filterForm,
                    callback: function($$v) {
                      _vm.filterForm = $$v
                    },
                    expression: "filterForm"
                  }
                },
                _vm._l(_vm.availableForms, function(f) {
                  return _c("el-option", {
                    key: f.id,
                    attrs: { label: f.name, value: f.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "cpm-toolbar__sel",
                  attrs: {
                    clearable: "",
                    placeholder: "All Statuses",
                    size: "small"
                  },
                  on: { change: _vm.onFilterChange },
                  model: {
                    value: _vm.filterStatus,
                    callback: function($$v) {
                      _vm.filterStatus = $$v
                    },
                    expression: "filterStatus"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: "Completed", value: "completed" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "Pending", value: "pending" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "Failed", value: "failed" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "Refunded", value: "refunded" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "cpm-toolbar__sel",
                  attrs: {
                    clearable: "",
                    placeholder: "All Gateways",
                    size: "small"
                  },
                  on: { change: _vm.onFilterChange },
                  model: {
                    value: _vm.filterGateway,
                    callback: function($$v) {
                      _vm.filterGateway = $$v
                    },
                    expression: "filterGateway"
                  }
                },
                [
                  _c("el-option", {
                    attrs: { label: "Stripe", value: "stripe" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "PayPal", value: "paypal" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "Razorpay", value: "razorpay" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "Mollie", value: "mollie" }
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: "Square", value: "square" }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "cpm-toolbar__search",
            attrs: {
              placeholder: "Search transactions…",
              "prefix-icon": "el-icon-search",
              clearable: "",
              size: "small"
            },
            on: { clear: _vm.onFilterChange },
            nativeOn: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.onFilterChange($event)
              }
            },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ]
        },
        [
          _c(
            "el-table",
            {
              staticClass: "cpm-table",
              attrs: { data: _vm.payments, stripe: "" }
            },
            [
              _c("el-table-column", {
                attrs: { label: "Transaction", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticClass: "cpm-txn" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                row.transaction_id
                                  ? "#" + row.transaction_id
                                  : "ID-" + row.id
                              ) +
                              "\n            "
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "Form",
                  "min-width": "160",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticClass: "cpm-form-name" }, [
                          _vm._v(_vm._s(row.form_title || "—"))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Customer", "min-width": "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticClass: "cpm-customer" }, [
                          _c("i", { staticClass: "el-icon-user" }),
                          _vm._v(
                            "\n              " +
                              _vm._s(row.customer_name || "Guest") +
                              "\n            "
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Gateway", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        row.gateway
                          ? _c(
                              "span",
                              {
                                staticClass: "cpm-gw",
                                class: "cpm-gw--" + row.gateway.toLowerCase()
                              },
                              [_vm._v(_vm._s(_vm.capitalize(row.gateway)))]
                            )
                          : _c("span", { staticClass: "cpm-gw" }, [_vm._v("—")])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Amount", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("strong", { staticClass: "cpm-amount" }, [
                          _vm._v("$" + _vm._s(_vm.formatAmount(row.total)))
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Status", width: "120", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "span",
                          {
                            staticClass: "cpm-status",
                            class: "cpm-status--" + (row.status || "unknown")
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.capitalize(row.status || "unknown")
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Date", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c("span", { staticClass: "cpm-date" }, [
                          _c("i", { staticClass: "el-icon-time" }),
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.formatDate(row.created_at)) +
                              "\n            "
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { width: "52", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tooltip",
                          { attrs: { content: "Delete", placement: "top" } },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "cpm-del",
                                on: {
                                  click: function($event) {
                                    return _vm.confirmDelete(row)
                                  }
                                }
                              },
                              [
                                _c("span", {
                                  staticClass: "dashicons dashicons-trash"
                                })
                              ]
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.loading && _vm.payments.length === 0
            ? _c(
                "div",
                { staticClass: "cpm-empty" },
                [
                  _c("span", {
                    staticClass: "dashicons dashicons-money-alt cpm-empty__icon"
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "cpm-empty__title" }, [
                    _vm._v("No payments found")
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "cpm-empty__sub" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.filterForm ||
                            _vm.filterStatus ||
                            _vm.filterGateway ||
                            _vm.search
                            ? "No payments match the current filters."
                            : "Payment records will appear here once customers complete transactions."
                        ) +
                        "\n        "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.filterForm ||
                  _vm.filterStatus ||
                  _vm.filterGateway ||
                  _vm.search
                    ? _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.clearFilters }
                        },
                        [_vm._v("\n          Clear Filters\n        ")]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.total > 0
        ? _c(
            "div",
            { staticClass: "cpm-footer" },
            [
              _c("span", { staticClass: "cpm-footer__count" }, [
                _vm._v(
                  _vm._s(_vm.total) +
                    " payment" +
                    _vm._s(_vm.total !== 1 ? "s" : "")
                )
              ]),
              _vm._v(" "),
              _vm.totalPages > 1
                ? _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager, next",
                      total: _vm.total,
                      "page-size": _vm.perPage,
                      "current-page": _vm.page
                    },
                    on: {
                      "update:currentPage": function($event) {
                        _vm.page = $event
                      },
                      "update:current-page": function($event) {
                        _vm.page = $event
                      },
                      "current-change": _vm.fetchPayments
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cpm-header" }, [
      _c("div", { staticClass: "cpm-header__left" }, [
        _c("div", { staticClass: "cpm-header__icon" }, [
          _c("span", { staticClass: "dashicons dashicons-money-alt" })
        ]),
        _vm._v(" "),
        _c("div", [
          _c("h1", { staticClass: "cpm-header__title" }, [
            _vm._v("Payment Transactions")
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "cpm-header__sub" }, [
            _vm._v("Track and manage all customer payments")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cpm-stat__icon-wrap" }, [
      _c("span", { staticClass: "dashicons dashicons-chart-line" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cpm-stat__icon-wrap" }, [
      _c("span", { staticClass: "dashicons dashicons-list-view" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cpm-stat__icon-wrap" }, [
      _c("span", { staticClass: "dashicons dashicons-yes-alt" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cpm-stat__icon-wrap" }, [
      _c("span", { staticClass: "dashicons dashicons-clock" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cpm-stat__icon-wrap" }, [
      _c("span", { staticClass: "dashicons dashicons-dismiss" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }